module.exports = __webpack_public_path__ + "img/set-scatter-plot-hover.1e547fca.svg";